import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {CookieService} from "ngx-cookie-service";
import { KazButtonComponent } from '../kaz-button/kaz-button.component';

@Component({
    selector: 'kaz-cookie-banner',
    templateUrl: './kaz-cookie-banner.component.html',
    styleUrls: ['./kaz-cookie-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [KazButtonComponent]
})
export class KazCookieBannerComponent implements OnInit{
  private _cookies = inject(CookieService);

  showCookies: boolean = false;

  ngOnInit(): void {

  }

  async acceptCookies(){
    this.showCookies = false;
  }

  async denyCookies(){
    this.showCookies = false;
  }

  async editCokkies(){
    this.showCookies = false;
  }
}
